import getConfig from 'next/config'
import TagManager from 'react-gtm-module'

const { publicRuntimeConfig } = getConfig()

export const GTM_ID = publicRuntimeConfig.GTM_ID as string | undefined

export const gtmInitialize = (): ReturnType<typeof TagManager.initialize> | undefined => {
  if (GTM_ID === undefined) return undefined
  return TagManager.initialize({ gtmId: GTM_ID })
}

export const trackEvent = (
  dataLayer: Record<string, unknown>,
): ReturnType<typeof TagManager.dataLayer> => {
  return TagManager.dataLayer({ dataLayer })
}

export const currentLocation = (): string => {
  return `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`
}
